"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useExternalEventSubscriptions(query) {
  const { ...rest } = useElements(
    "external-event-subscriptions",
    query
  );
  return {
    externalEventSubscriptions: rest.items,
    ...rest
  };
}

export { useExternalEventSubscriptions };
